import React from 'react';
import RouteHomepage from '../../router/route';

const BodyHomepage: React.FC = () => {
  return <RouteHomepage />;
};

export default React.memo(BodyHomepage);
